// activityHistory.js — Activity History modal content
// Receives the selected module as a prop from moduleMetricsPage.js.
// Rendered inside the shared Modal component.

import React from "react";

const JobStatusBadge = ({ status }) => {
  const statusClasses = {
    Completed: "mm-job-badge--completed",
    "In Progress": "mm-job-badge--inprogress",
    Pending: "mm-job-badge--pending",
  };

  return (
    <span className={`mm-job-badge ${statusClasses[status] || ""}`}>
      {status}
    </span>
  );
};

const ActivityHistory = ({ module }) => {
  // Null safety check
  if (!module) {
    return (
      <div className="mm-activity-content">
        <p className="modal-description">No module selected</p>
      </div>
    );
  }

  const { workOrder, itemNumber, batchNumber, activityHistory = [] } = module;

  return (
    <>
      <p className="modal-description">
        Job history for {workOrder} &mdash; {itemNumber} &bull; {batchNumber}
      </p>

      <div className="modal-section modal-section--scroll">
        <h3>Job Activity</h3>

        {activityHistory.length === 0 ? (
          <p className="modal-empty-state">
            No activity history available for this module.
          </p>
        ) : (
          <div className="modal-table-scroll">
            <table className="modal-table">
              <thead>
                <tr>
                  <th>Job Name</th>
                  <th>Job ID</th>
                  <th>Status</th>
                  <th>Workers</th>
                  <th>Last Updated</th>
                </tr>
              </thead>
              <tbody>
                {activityHistory.map((row) => (
                  <tr key={row.jobId}>
                    <td>{row.jobName}</td>
                    <td>{row.jobId}</td>
                    <td>
                      <JobStatusBadge status={row.status} />
                    </td>
                    <td>{row.workers}</td>
                    <td>{row.lastUpdated}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
};

export default ActivityHistory;
